<template>
	<div class="sf-search-layout__body__container">
		<sf-search-layout>
			<el-row :gutter="20">
				<!-- 고품상태 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC000963')"
						paramKey="rptpSt"
						:options="rptpStList"
						:propData="searchParams.rptpSt"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>
				<!-- 회수방법 -->
				<el-col :span="3">
					<select-combo
						:label="getMessage_('QWCC001906')"
						paramKey="clctWay"
						:options="clctWayList"
						:propData="searchParams.clctWay"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>

				<el-col :span="3">
					<select-combo
						:label="getMessage_('\u00A0')"
						paramKey="srchMm"
						:options="srchMmList"
						:propData="searchParams.srchMm"
						@commChange="setSearchParam"
					></select-combo>
				</el-col>

				<!--회수 요청일 -->
				<el-col :span="5">
					<sf-group-wrapper :label="getMessage_('\u00A0')">
						<el-date-picker
							v-model="searchAplcDdDt"
							@change="changeSearchAplcDdDt"
							type="daterange"
							align="right"
							:start-placeholder="getMessage_('QWCC000920')"
							:end-placeholder="getMessage_('QWCC000954')"
							range-separator="~"
							format="yyyy-MM-dd"
							style="height: 38px"
						/>
					</sf-group-wrapper>
				</el-col>

				<!--원인부품번호-->
				<el-col :span="4">
					<rtn-part-mst-search-input :label="getMessage_('QWCC000975')" paramKey="causPartNo"> </rtn-part-mst-search-input>
				</el-col>
				<el-col :span="4">
					<rtn-part-mst-search-input
						:label="getMessage_('QWCC000959')"
						paramKey="dlrCpnyCd"
						@commChange="setSearchParam"
					/><!--다국어 등록시 메세지 ID MWCC 시스템은 센터 메세지 타입은 라벨로 선택하고 등록함-->
				</el-col>
			</el-row>
			<template slot="button">
				<sf-button line icon="search" :onClick="() => searchList()" v-if="isButton_(scrId, 'CR')">
					{{ getButtonMsg_(scrId, 'CR') }}
				</sf-button>
			</template>
		</sf-search-layout>
	</div>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/ceqi/RtnPartMst/store/helpers';
import RtnPartMstSearchInput from './RtnPartMstSearchInput.vue';
import SelectCombo from '@qms/Components/SelectCombo';
import qmsUtils from '@/store/qms/api';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //클레임 승인현황에서 시작일자 가져옴
		pEndDt: { type: String, default: '' }, //클레임 승인현황에서 종료일자 가져옴
		pState1: { type: String, default: '' }, //클레임 승인현황에서 처리단계 가져옴
		pState2: { type: String, default: '' }, //클레임 승인현황에서 처리결과 가져옴
		pState3: { type: String, default: '' }, //클레임 승인현황에서 날짜 검색조건 가져옴
	},

	data() {
		return {
			searchAplcDdDt: ['', ''],
			searchDcsnDdDt: ['', '']
		};
	},
	components: { RtnPartMstSearchInput, SelectCombo },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...serviceMethods,
		setSearchParam(param) {
			this.setSearchParam_(param);
		},
		ChangeDlrCpnyCd(value) {
			this.dlrCpnyCd = value;
			this.dlrCpnyCdNm = value;
		},
		searchList() {
			// console.log('--------dlrCpnyCd', this.dlrCpnyCd);
			this.$sf_toggleLoading(true);
			this.getRtnPartMstList_()
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		changeSearchAplcDdDt(data) {
			let from;
			let to;

			if (data) {
				from = this.$moment(data[0]).format('YYYY-MM-DD');
				to = this.$moment(data[1]).format('YYYY-MM-DD');
			} else {
				from = '';
				to = '';
			}

			this.searchAplcDdDt = [from, to];
			this.setSearchParam_({ key: 'startDd', value: from });
			this.setSearchParam_({ key: 'endDd', value: to });
		}
	},
	async created() {
		try {
			await this.getCommCodes_({ key: 'rptpStList', codeType: 'RPTP_ST' });
			await this.getCommCodes_({ key: 'srchMmList', codeType: 'SRCH_MM_99' });
			await this.getCommCodes_({ key: 'clctWayList', codeType: 'CLCT_WAY' }); //수요상태 콤보박스

			/*클레임 승인내역에서 넘어오는 파라미터 값 시작*/
			let pStartDt = this.pStartDt || '';
			let pEndDt = this.pEndDt || '';
			let pState1 = this.pState1 || ''; 
			let pState2 = this.pState2 || '';
			let pState3 = this.pState3 || ''; // 날짜 검색조건

			pStartDt = pStartDt != '' ? this.$moment(pStartDt).format('YYYY-MM-DD') : '';
			pEndDt = pEndDt != '' ? this.$moment(pEndDt).format('YYYY-MM-DD') : '';

			//state안에 초기화 되어있는 값을 개터스 함수로 꺼내서 셋팅한다.
			this.searchAplcDdDt = [this.getStartDd_, this.getEndDd_];

			if (this.isMqyStation) {
				let result = await qmsUtils.getDeptNm(this.user.deptCd);

				this.setSearchParam_({ key: 'dlrCpnyCd', value: result.deptCd });
				this.ChangeDlrCpnyCd(result.deptCd);
				
			} else {
				this.setSearchParam_({ key: 'dlrCpnyCd', value: '' });
			}

			if (!pStartDt && pEndDt) {
				this.setSearchParam_({ key: 'startDd', value: this.getStartDd_ });
				this.setSearchParam_({ key: 'endDd', value: this.getEndDd_ });
				this.searchAplcDdDt = [this.getStartDd_, this.getEndDd_];
			} else {
				this.setSearchParam_({ key: 'rptpSt', value: pState1 });
				this.setSearchParam_({ key: 'clctWay', value: pState2 });
				this.setSearchParam_({ key: 'srchMm', value: pState3 });
				this.setSearchParam_({ key: 'startDd', value: pStartDt });
				this.setSearchParam_({ key: 'endDd', value: pEndDt });
				this.searchAplcDdDt = [pStartDt, pEndDt];
			}

			// console.log('+++++++++++', this.searchParams);
			await this.searchList();
		} catch (error) {
			this.$sf_toast({
				type: 'error',
				message: error.message
			});
			return error;
		}
	}
};
</script>

<style></style>
